export default __webpack_public_path__ + "static/media/nodo4000.008999a4.svg";